export const WORKING_LABEL = "Working on your request";
export const PREPARING_LABEL = "Preparing your answer";
export const STILL_WORKING_LABEL = "Still working on it…";

const RUNNING_TOOL_STATES = new Set(["input-streaming", "input-available"]);

function getToolName(part) {
  if (part?.type === "dynamic-tool") return part.toolName || "";
  if (part?.type?.startsWith("tool-")) return part.type.slice("tool-".length);
  return null;
}

// Labels come only from tool identity, never from tool inputs or outputs.
export function getToolLabel(toolName) {
  const name = String(toolName || "");
  if (/^algolia_search_index_.*_products$/.test(name)) return "Searching products";
  if (/^algolia_search_index_.*_suppliers$/.test(name)) return "Checking suppliers";
  if (name === "web_search_exa" || name === "web_fetch_exa") return "Searching the web";
  if (name === "search_historical_products") return "Looking for alternatives";
  if (name === "get_rfq_categories") return "Preparing RFQ options";
  return WORKING_LABEL;
}

const DONE_LABELS = {
  "Searching products": "Searched products",
  "Checking suppliers": "Checked suppliers",
  "Searching the web": "Searched the web",
  "Looking for alternatives": "Looked for alternatives",
  "Preparing RFQ options": "Prepared RFQ options",
  [WORKING_LABEL]: "Finished a step",
};

// A tool call that errored is shown as not done, so shoppers are not told it worked.
const FAILED_LABELS = {
  "Searching products": "Couldn't search products",
  "Checking suppliers": "Couldn't check suppliers",
  "Searching the web": "Couldn't search the web",
  "Looking for alternatives": "Couldn't look for alternatives",
  "Preparing RFQ options": "Couldn't load RFQ options",
  [WORKING_LABEL]: "A step didn't finish",
};

// One step per tool call, in stream order, so repeat searches get their own line.
// Each step also carries Charli's userIntent for that tool call, as plain text, shortened for display.
export function getProgressSteps(message) {
  return (message?.parts || [])
    .filter(part => getToolName(part) !== null)
    .map(part => {
      const label = getToolLabel(getToolName(part));
      const done = !RUNNING_TOOL_STATES.has(part.state);
      const failed = part.state === "output-error";
      const step = { label: failed ? FAILED_LABELS[label] : (done ? DONE_LABELS[label] : label), done };
      if (failed) step.failed = true;
      const intent = getIntentPreview(part.input?.userIntent);
      if (intent) step.detail = intent;
      return step;
    });
}

function getIntentPreview(value) {
  if (typeof value !== "string") return "";
  const text = value.replace(/\s+/g, " ").trim();
  return text.length > 160 ? `${text.slice(0, 157)}…` : text;
}
